module.exports = __webpack_public_path__ + "static/media/DSCF0486-N8noiYgs.95e9418f.JPG";